export default __webpack_public_path__ + "static/media/tempestofset_white_icon.30bfb8d3.png";